/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsUpdateDestination } from "../funcs/dataExportsUpdateDestination.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Destination } from "../models/components/destination.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateDataExportDestinationRequest,
  UpdateDataExportDestinationSecurity,
} from "../models/operations/updatedataexportdestination.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateDataExportDestinationMutationVariables = {
  request: UpdateDataExportDestinationRequest;
  security?: UpdateDataExportDestinationSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateDataExportDestinationMutationData = Destination;

export type UpdateDataExportDestinationMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateDestination dataExports
 *
 * @remarks
 * Replace a data export destination in the selected project.
 */
export function useUpdateDataExportDestinationMutation(
  options?: MutationHookOptions<
    UpdateDataExportDestinationMutationData,
    UpdateDataExportDestinationMutationError,
    UpdateDataExportDestinationMutationVariables
  >,
): UseMutationResult<
  UpdateDataExportDestinationMutationData,
  UpdateDataExportDestinationMutationError,
  UpdateDataExportDestinationMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateDataExportDestinationMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateDataExportDestination(): MutationKey {
  return ["@gram/client", "dataExports", "updateDestination"];
}

export function buildUpdateDataExportDestinationMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateDataExportDestinationMutationVariables,
  ) => Promise<UpdateDataExportDestinationMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateDataExportDestination(),
    mutationFn: function updateDataExportDestinationMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateDataExportDestinationMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dataExportsUpdateDestination(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
